import { ReactNode } from "react";

import { UserContextProvider } from "features/account";
import { PersonalDataContextProvider } from "features/personal-data";
import { BreachesContextProvider } from "features/breaches";
import { OpenLeakContextProvider } from "features/openleak";
import { NotificationContextProvider } from "features/notifications";
import { DashboardProContextProvider } from "features/dashboard-pro";
import { AccompaniementsContextProvider } from "features/accompaniment";
import { DocumentsContextProvider } from "features/documents";
import { FolderContextProvider } from "features/documents";

/**
 * Composition des Context providers de l'application.
 * L'ordre d'imbrication est significatif (certains contexts en consomment
 * d'autres) — il reproduit à l'identique l'ancienne pyramide d'App.tsx.
 * BrowserRouter reste en amont (dans App) car des contexts utilisent les
 * hooks de react-router.
 */
const AppProviders = ({ children }: { children: ReactNode }) => (
  <UserContextProvider>
    <PersonalDataContextProvider>
      <BreachesContextProvider>
        <OpenLeakContextProvider>
          <NotificationContextProvider>
            <DashboardProContextProvider>
              <AccompaniementsContextProvider>
                <DocumentsContextProvider>
                  <FolderContextProvider>
                    {children}
                  </FolderContextProvider>
                </DocumentsContextProvider>
              </AccompaniementsContextProvider>
            </DashboardProContextProvider>
          </NotificationContextProvider>
        </OpenLeakContextProvider>
      </BreachesContextProvider>
    </PersonalDataContextProvider>
  </UserContextProvider>
);

export default AppProviders;
